import axios from "axios";
import { useState } from "react";

const api = axios.create({
  baseURL: "https://api.basik.protechadvance.com/api/v1",
  headers: {
    "X-Api-Public-Key": "tbs_pk_-MAKMNET8tLNxzVQKzbz-n3FnlNF3MOY",
    "X-Api-Secret-Key": "tbs_sk_un5FDqDuE5GOzIfxOpKDvFsNkOSRoMMpTrGGji_z_rY",
  },
});

export default function Home() {
  const [isLoading, setIsLoading] = useState(false);

  const createSession = async (templateId: string) => {
    try {
      setIsLoading(true);
      const response = await api.post(`/partner/templates/${templateId}/initiator-sessions`, {
        redirect_url: window.location.origin,
        context_reference: "transaction-29374",
        first_signer_email: "cugwuh182@gmail.com",
        first_signer_name: "Jordan Signer",
        message: "Please sign this agreement to activate your listing.",
      });
      const data = response.data;
      if (data?.first_signing_url) window.location.href = data.first_signing_url;
    } catch (error) {
      console.error("Error signing document:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const getTemplates = async () => {
    try {
      setIsLoading(true);
      const response = await api.get("/partner/templates/");
      const data = response.data;
      const templateId = data[0]?.id;
      if (templateId) {
        await createSession(templateId);
      }
    } catch (error) {
      console.error("Error fetching templates:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="flex justify-center items-center h-screen">
      <button
        onClick={getTemplates}
        disabled={isLoading}
        className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 disabled:bg-gray-400"
      >
        {isLoading ? "Loading..." : "Click to sign"}
      </button>
    </div>
  );
}
